/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreateMilestoneRequest,
    CreateMilestoneRequestFromJSON,
    CreateMilestoneRequestFromJSONTyped,
    CreateMilestoneRequestToJSON,
    OWLogCategory,
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    OWRewardMaxType,
    OWRewardMaxTypeFromJSON,
    OWRewardMaxTypeFromJSONTyped,
    OWRewardMaxTypeToJSON,
    OWRewardMode,
    OWRewardModeFromJSON,
    OWRewardModeFromJSONTyped,
    OWRewardModeToJSON,
    QuestReset,
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
} from './';

/**
 * 
 * @export
 * @interface OWQuestBody
 */
export interface OWQuestBody {
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    game?: string;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof OWQuestBody
     */
    name: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof OWQuestBody
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and tracks in the BE) or not.
     * @type {boolean}
     * @memberof OWQuestBody
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof OWQuestBody
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof OWQuestBody
     */
    questCompleteNotificationMessage?: string;
    /**
     * The maximum amount of reward that can be claimed.
     * @type {number}
     * @memberof OWQuestBody
     */
    rewardMax?: number;
    /**
     * 
     * @type {OWRewardMaxType}
     * @memberof OWQuestBody
     */
    rewardMaxType?: OWRewardMaxType;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof OWQuestBody
     */
    rewardCategory: OWLogCategory;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    eventType: string;
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof OWQuestBody
     */
    target: number;
    /**
     * 
     * @type {QuestReset}
     * @memberof OWQuestBody
     */
    questReset?: QuestReset;
    /**
     * If the quest is available for all supported games that are not in our database (OWGames).
     * @type {boolean}
     * @memberof OWQuestBody
     */
    onAllSupportedGames?: boolean;
    /**
     * 
     * @type {OWRewardMode}
     * @memberof OWQuestBody
     */
    mode?: OWRewardMode;
    /**
     * Ref to the challenge of this quest (only for challenge quests).
     * @type {string}
     * @memberof OWQuestBody
     */
    challenge?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OWQuestBody
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    rewardImage?: string;
    /**
     * 
     * @type {number}
     * @memberof OWQuestBody
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof OWQuestBody
     */
    endAt?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWQuestBody
     */
    rewardConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<CreateMilestoneRequest>}
     * @memberof OWQuestBody
     */
    milestones?: Array<CreateMilestoneRequest>;
}

export function OWQuestBodyFromJSON(json: any): OWQuestBody {
    return OWQuestBodyFromJSONTyped(json, false);
}

export function OWQuestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWQuestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'game': !exists(json, 'game') ? undefined : json['game'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': !exists(json, 'showQuestCompleteNotification') ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': !exists(json, 'questCompleteNotificationMessage') ? undefined : json['questCompleteNotificationMessage'],
        'rewardMax': !exists(json, 'rewardMax') ? undefined : json['rewardMax'],
        'rewardMaxType': !exists(json, 'rewardMaxType') ? undefined : OWRewardMaxTypeFromJSON(json['rewardMaxType']),
        'rewardCategory': OWLogCategoryFromJSON(json['rewardCategory']),
        'eventType': json['eventType'],
        'target': json['target'],
        'questReset': !exists(json, 'questReset') ? undefined : QuestResetFromJSON(json['questReset']),
        'onAllSupportedGames': !exists(json, 'onAllSupportedGames') ? undefined : json['onAllSupportedGames'],
        'mode': !exists(json, 'mode') ? undefined : OWRewardModeFromJSON(json['mode']),
        'challenge': !exists(json, 'challenge') ? undefined : json['challenge'],
        'isSponsored': !exists(json, 'isSponsored') ? undefined : json['isSponsored'],
        'sponsorName': !exists(json, 'sponsorName') ? undefined : json['sponsorName'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
        'rewardImage': !exists(json, 'rewardImage') ? undefined : json['rewardImage'],
        'startAt': !exists(json, 'startAt') ? undefined : json['startAt'],
        'endAt': !exists(json, 'endAt') ? undefined : json['endAt'],
        'rewardConfigIds': !exists(json, 'rewardConfigIds') ? undefined : json['rewardConfigIds'],
        'milestones': !exists(json, 'milestones') ? undefined : ((json['milestones'] as Array<any>).map(CreateMilestoneRequestFromJSON)),
    };
}

export function OWQuestBodyToJSON(value?: OWQuestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'game': value.game,
        'name': value.name,
        'description': value.description,
        'isActive': value.isActive,
        'showQuestCompleteNotification': value.showQuestCompleteNotification,
        'questCompleteNotificationMessage': value.questCompleteNotificationMessage,
        'rewardMax': value.rewardMax,
        'rewardMaxType': OWRewardMaxTypeToJSON(value.rewardMaxType),
        'rewardCategory': OWLogCategoryToJSON(value.rewardCategory),
        'eventType': value.eventType,
        'target': value.target,
        'questReset': QuestResetToJSON(value.questReset),
        'onAllSupportedGames': value.onAllSupportedGames,
        'mode': OWRewardModeToJSON(value.mode),
        'challenge': value.challenge,
        'isSponsored': value.isSponsored,
        'sponsorName': value.sponsorName,
        'logo': value.logo,
        'color': value.color,
        'externalUrl': value.externalUrl,
        'rewardImage': value.rewardImage,
        'startAt': value.startAt,
        'endAt': value.endAt,
        'rewardConfigIds': value.rewardConfigIds,
        'milestones': value.milestones === undefined ? undefined : ((value.milestones as Array<any>).map(CreateMilestoneRequestToJSON)),
    };
}


